import { StubbornAttribute } from '../../../../../../../../business/StubbornAttributeMapping';

export const makeComponentAttributeGroup = (attributes: Set<StubbornAttribute>) => ({
  label: 'Component',
  name: 'component',
  priority: 1,
  attributes,
});
